import defaultSettings from '@/settings';
import store from '@/store'

const title = store.getters.config.platformTitle || defaultSettings.title;

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
}
